import React, { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";
import Disconneted from "../../assets/disconneted.jpeg";
import { isCrispChatEnabled } from "../../cores/config/featureFlags";
import WaitingGameOffer from "../component/games/WaitingGameOffer";
import "./ConnectionIssue.scss";

const SUPPORT_EMAIL = "soporte@wembii.com";

export const ConnectionIssuePage = () => {
  const intl = useIntl();

  const userWantsSupport = useCallback(async () => {
    if (isCrispChatEnabled()) {
      // @ts-ignore
      const $crisp = window["$crisp"];
      if ($crisp) {
        $crisp.push(["do", "chat:open"]);
        $crisp.push([
          "set",
          "message:text",
          [
            "¡Hola! Tengo inconvenientes para ingresar a Wembii y necesito su asistencia",
          ],
        ]);
        return;
      }
    }
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
      "Problemas de conexión - Wembii"
    )}`;
  }, []);

  return (
    <div className="connection-issue-page">
      <div className="connection-issue-page__ambient" aria-hidden />
      <div className="connection-issue-page__shell">
        <div className="connection-issue-page__card">
          <div className="connection-issue-page__badge">Sin conexión</div>

          <div className="connection-issue-page__illustration">
            <div className="connection-issue-page__icon-glow" />
            <img
              className="connection-issue-page__img"
              src={Disconneted}
              alt=""
            />
          </div>

          <h1 className="connection-issue-page__title">Problemas de conexión</h1>
          <p className="connection-issue-page__text">
            Estamos experimentando problemas de conexión. Comprueba tu conexión
            a internet o vuelve a intentarlo más tarde.
          </p>

          <div className="connection-issue-page__support">
            <span>Si tienes dudas o necesitas ayuda,</span>
            <button
              type="button"
              onClick={userWantsSupport}
              className="connection-issue-page__support-link"
            >
              comunícate con soporte
            </button>
          </div>

          <button
            type="button"
            onClick={() => window.location.reload()}
            className="connection-issue-page__retry"
          >
            <FontAwesomeIcon
              icon={faArrowRotateRight}
              className="connection-issue-page__retry-icon"
              aria-hidden
            />
            Reintentar conexión
          </button>
        </div>
      </div>

      <WaitingGameOffer
        isWaiting
        promptTitle={intl.formatMessage({
          id: "app.connection.dinoPromptTitle",
        })}
        promptLead={intl.formatMessage({
          id: "app.connection.dinoPromptLead",
        })}
        promptQuestion={intl.formatMessage({
          id: "app.connection.dinoPromptQuestion",
        })}
        gameNote={intl.formatMessage({ id: "app.connection.dinoGameNote" })}
        closeButtonLabel={intl.formatMessage({
          id: "app.connection.dinoCloseGame",
        })}
      />
    </div>
  );
};
